import api from '../api';

export const getPerformance = (token) =>
	api({
		method: 'get',
		url: `performance/${token}`
	});
